<template>
  <el-container class="body_container">
    <el-header style="height: 100px;padding:0px">
      <el-row class="body_title">优质课件</el-row>
      <el-form v-model="searchVo" :inline="true" ref="search">
        <el-row type="flex">
          <el-col>
            <el-form-item prop="category" label="类型" label-width="40px"  size="small">
              <el-select v-model="searchVo.category" placeholder="请选择" style="width: 100px">
                <el-option label="标题" value="title"></el-option>
                <el-option label="讲师姓名" value="name"></el-option>
              </el-select>
              <el-input v-model="searchVo.title" placeholder="输入查询内容"  style="width: 160px">
                <el-button  @click="search" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item class="dialog-footer" >
              <el-button type="primary" @click="search">查询</el-button>
              <el-button @click="resetForm('search')" style="background-color: #fff;border: 1px solid #3e64ff;color: #3e64ff;padding: 7px 12px">重置</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="text-align: right">
            <el-form-item class="dialog-footer" >
              <el-button  @click="add('addLive')" type="primary">添加</el-button>
              <!--添加视频弹窗组件 -->
              <add-courseware ref="addBranch" v-if="addCoursewareVisible" :visible.sync="addCoursewareVisible" :values="coursewareId" @callFather="reload"></add-courseware>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-header>
    <el-main class="search_result">
      <el-table :data="coursewares.list">
        <el-table-column prop="title" :show-overflow-tooltip="true" label="标题" min-width="300px"></el-table-column>
        <el-table-column prop="name" label="讲师姓名" min-width="120px"></el-table-column>
        <el-table-column prop="img" label="内容照片" min-width="200px">
          <template   slot-scope="scope">
            <img :src="scope.row.coverUrl"  min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" sortable label="上传时间" min-width="180px"></el-table-column>
        <el-table-column label="必学视频" min-width="90px">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.fineVideo"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="0"
              inactive-value="1"
              @change="changeSwitch(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="id" width="120px" label="操作">
          <template slot-scope="scope">
              <i class="el-icon-edit" @click="checkCourseware(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
              <i class="el-icon-delete" @click="delCourseware(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            <span v-if="scope.row.id !== firstId">
              <el-tooltip class="item" effect="dark" content="向上排序" placement="left">
                <i class="el-icon-top" @click="upward(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
              </el-tooltip>
            </span>
            <span v-if="scope.row.id !== lastId">
              <el-tooltip class="item" effect="dark" content="向下排序" placement="left">
                <i class="el-icon-bottom" @click="downword(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-pagination class="page"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-size="coursewares.rows"
      :current-page="coursewares.page"
      layout="prev, pager, next, jumper"
      :total="coursewares.total">
    </el-pagination>
  </el-container>
</template>

<script>
import Courseware from './courseware/Courseware.vue'
// import video from '@/api/video'
import courseware from '@/api/courseware'
export default {
  name: 'Courseware',
   components: {
    'add-courseware': Courseware
  },
  data () {
    return {
      url: 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/',
      coursewareId: null,
      addCoursewareVisible: false,
      coursewares: {
        page: 1,
        rows: 10,
        total: 0,
        list: []
      },
      lastId: 0,
      firstId: 0,
      searchVo: {
        category: '',
        title: '',
        startTime: '',
        endTime: ''
      },
      value2: '1',
      page: 1,
      size: 10
    }
  },
  created () {
    this.reload()
    this.getLastId()
  },
  methods: {
    // 向上排序
    upward (row) {
      let obj = {
        id: row.id,
        move: 'top'
      }
      courseware.move(obj).then(res => {
        this.$message.info(res.data.message)
        if (res.data.code===0){
          this.reload()
          this.getLastId()
        }
      })
    },
    // 向下排序
    downword (row) {
      let obj = {
        id: row.id,
        move: 'down'
      }
      courseware.move(obj).then(res => {
        this.$message.info(res.data.message)
        if (res.data.code===0){
          this.reload()
          this.getLastId()
        }
      })
    },
    checkCourseware (row) {
      this.coursewareId = row.id
      // console.log(this.coursewareId)
      this.addCoursewareVisible = true
    },
    delCourseware (row) {
      this.$confirm('此操作将删除该课件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        courseware.del({id: row.id}).then(res => {
          this.$message.info(res.data.message)
         if (res.data.code===0){
           this.reload()
           this.getLastId()
         }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.page = val
      this.reload()
    },
    // 精品视频
    changeSwitch (row) {
      // console.log(row.fineVideo)
      // console.log(row.id)
      let obj = {
        id: row.id,
        fineVideo: row.fineVideo
      }
      courseware.save(obj).then(res => {
        if (res.data.code === 0){
          this.$message.success('设置成功')
          this.reload()
        }else {
          this.$message.error('设置失败')
        }
      })
    },
    // 获取第一个最后一个数据的ID
    getLastId () {
      courseware.find({status: '1' }).then(res => {
        this.firstId = res.data.data[0].id
        this.lastId = res.data.data[res.data.data.length - 1].id
        // console.log(this.lastId)
        // console.log(this.firstId)
      })
    },
    reload () {
      courseware.find({page: this.page, limit: this.size, status: '1' }).then(res => {
        this.coursewares = res.data.data
        // console.log(this.coursewares)
      })
    },
    formatterColumn (row, column) {
      return row.cwStatus === '0' ? '正在上传' : row.cwStatus === '1' ? '已上传' : row.cwStatus === '2' ? '已取消' :row.cwStatus === '9' ? '已停播' : ''
    },
    add (refForm) {
      this.coursewareId = null
      if (this.$refs[refForm]) {
        this.$refs[refForm].initForm()
      }
      this.addCoursewareVisible = true
    },
    // userStatus (row, col) {
    //   if (row['userStatus'] === '1') {
    //     return this.options[1].label
    //   } else if (row['userStatus'] === '0') {
    //     return this.options[2].label
    //   }
    // },
    search () {
      this.page = 1
      let obj={}
      obj[this.searchVo.category]  = this.searchVo.title
      obj.page = this.page
      obj.limit = this.size
      // obj.startTime = this.searchVo.startTime
      // obj.endTime = this.searchVo.endTime
      obj.status = '1'
      // console.log(obj)
      courseware.find(obj).then(res => {
        this.coursewares = res.data.data
        // console.log(this.coursewares)
      })
    },
    // 重置form
    resetForm (formName) {
      this.searchVo.category = ''
      this.searchVo.title = ''
      // this.searchVo.startTime = ''
      // this.searchVo.endTime = ''
      this.reload()
    },
    updateData (val) {
      this.page = val
      this.reload()
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/video/Courseware.vue